import React from "react";
//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { HoldingRegisterFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { AutocompleteListItem } from "models/propTypes/listPropTypes";
import { WintSuperkollAPIModelAccounting } from "wint-api-client/dist/types";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import useCommonFilterProps from "./useCommonFilterProps";
//#endregion
import { useAccountService } from "serviceHooks";
import { QueryStateHelper } from "utils/helpers";

function useHoldingRegisterReportFilterDefinition() {
  const accountService = useAccountService();
  const [accounts, setAccounts] = React.useState<AutocompleteListItem[]>([]);
  const {
    generalFilterFormFields,
    dateFilterFormFields,
    filterQueryStateHandler: baseFilterQueryStateHandler,
  } = useCommonFilterProps();

  React.useEffect(() => {
    accountService.getAccounts({ active: true } as WintSuperkollAPIModelAccounting.AccountFilter).then((res) => {
      const accountsRes =
        res?.items?.map((s) => ({
          id: s.id,
          value: s.number.toString() ?? "",
          description: s.name,
        })) ?? [];
      setAccounts(accountsRes);
    });
  }, []);

  const filterFormFields: GenericFormSection<HoldingRegisterFormTypes.HoldingRegisterFilter>[] = [
    {
      label: TranslationKeys.Common.Dates,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: dateFilterFormFields,
    },
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        assetAccountNumber: {
          label: TranslationKeys.HoldingRegister.AssetAccount,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          extraProps: {
            referenceFieldName: FormFieldConstants.HoldingRegister.HoldingRegisterFilter.AssetAccountName,
            items: accounts,
          },
        },
        depreciationAccountNumber: {
          label: TranslationKeys.HoldingRegister.DepreciatingAccount,
          type: FormEnums.FormFieldType.AUTOCOMPLETE,
          extraProps: {
            referenceFieldName: FormFieldConstants.HoldingRegister.HoldingRegisterFilter.DepreciationAccountName,
            items: accounts,
          },
        },
        ...generalFilterFormFields,
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<HoldingRegisterFormTypes.HoldingRegisterFilter> = {
    assetAccountNumber: QueryStateHelper.numberQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterFilter.AssetAccountNumber
    ),
    depreciationAccountNumber: QueryStateHelper.numberQueryEncoder(
      FormFieldConstants.HoldingRegister.HoldingRegisterFilter.DepreciationAccountNumber
    ),
    ...baseFilterQueryStateHandler,
  };

  return { filterFormFields, filterQueryStateHandler };
}

export default useHoldingRegisterReportFilterDefinition;
